import { useDossierDataStore } from "@/store/useDossierDataStore";
import { computed } from "vue";

export function useIvoDossierContext() {
	const dossierDataStore = useDossierDataStore();
	const hasOnderneming = computed(() =>
		dossierDataStore.data.income.byCustomer.some(
			(income) => (income.sections.onderneming?.length ?? 0) > 0,
		),
	);
	const hasIvo = computed(() =>
		dossierDataStore.data.income.byCustomer.some(
			(income) => (income.sections.ivo?.length ?? 0) > 0,
		),
	);
	const nhg = computed(() => {
		const useNHG = dossierDataStore.data.financieringsOpzet.useNHG;
		if (useNHG === "Ja") return true;
		if (useNHG === "Nee") return false;
		return undefined;
	});

	return { hasOnderneming, hasIvo, nhg };
}
